<template>
  <main class="admin-team__main"> 
    <div class="employes">
      <employer-header> <h4>Facturas</h4></employer-header>
      <div class="filters">
        <v-date-picker v-model="range" mode="date" is-range>
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex justify-center items-center">
              <input
                  :value="inputValue.start"
                  v-on="inputEvents.start"
                  class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                  />
                <input
                    :value="inputValue.end"
                    v-on="inputEvents.end"
                    class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                    />
            </div>
          </template>
        </v-date-picker>
        <div class="filter-invoices">
          <button @click="filterInvoices" 
                    type="submit"
                    class="ceu-btn1">
           Filtrar facturas 
          </button>
        </div>
        <div class="filter-invoices">
          <button @click="getReport" 
                    type="submit"
                    class="ceu-btn1">
           exportar facturas 
          </button>
        </div>
        <div class="filter-invoices">
          <button @click="showModalSearch = true" 
                    type="submit"
                    class="ceu-btn1">
            Buscar factura 
          </button>
        </div>
        <img @click="openModal" src="../assets/images/vitrinas-icons/create.png">
      </div>
      <div style="height: 100%" class="loans">
        <invoice :key="invoice.id" v-for="invoice in getInvoices"
          :number="invoice.number"
          :total="invoice.total"
          :status="invoice.status"
          :seller="invoice.seller"
          :id="invoice.id"
          :date="invoice.date"
          :remaining="invoice.remaining"
          :note="invoice.note"
        />
      </div>
    </div>
      <update-file
      @toggle-modal="toggleModal"
      :show-modal="showModal" />      
      <search-invoice
      @toggle-modal="showModalSearch = false"
      :show-modal="showModalSearch" />      
  </main>
</template>


<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import configService from '../settings/api-url'
import employerHeader from '../components/humanManagment/header'
import  createButton from '../components/humanManagment/createButton'
import invoice from '../components/invoices/invoice.vue'
import updateFile from '../components/modals/uploadFile.vue'
import searchInvoice from '../components/modals/searchInvoice.vue'
export default {
  data (){
    return {
      showModal: false,
      showModalSearch: false,
      range: {
        start: new Date,
        end: new Date
      }
    }
  },
  computed: {
    ...mapState(['invoices']),
    ...mapGetters(['getInvoices'])
  },
  components: {
    createButton,
    employerHeader,
    invoice,
    updateFile,
    searchInvoice
  },
  methods: {
    ...mapMutations(['setInvoices']),
    toggleModal () {
      this.showModal = false
      this.filterInvoices()
    },
    async filterInvoices () {
      console.log(this.range)
      const { data } = await configService(`admin/invoices?start=${this.range.start}&end=${this.range.end}`)
      this.setInvoices(data)
    },
    openModal () {
      this.showModal = true
    },
    async getReport () {
      const { data } = await configService(`admin/invoices_report?start=${this.range.start}&end=${this.range.end}`)
      var myBlob =  new Blob([this.s2ab(atob(data))], {type: ''});
      var url = window.URL.createObjectURL(myBlob);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = "report_facturas.xls";
      a.click();
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
  },
  async created () {
    if (this.invoices.length === 0) {
      const { data } = await configService(`admin/invoices?start=${this.range.start}&end=${this.range.end}`)
      this.setInvoices(data)
    }
  },
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>
